import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredApple = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8.75809 3.69231C9.45541 3.69231 10.3295 3.20407 10.8501 2.55308C11.3215 1.96313 11.6652 1.13922 11.6652 0.315321C11.6652 0.203433 11.6554 0.0915448 11.6358 0C10.8599 0.0305149 9.92684 0.539098 9.36702 1.2206C8.92505 1.73935 8.52237 2.55308 8.52237 3.38716C8.52237 3.50922 8.54202 3.63128 8.55184 3.67196C8.60095 3.68214 8.67952 3.69231 8.75809 3.69231ZM6.30273 16C7.25541 16 7.67773 15.3388 8.86612 15.3388C10.0742 15.3388 10.3393 15.9797 11.4001 15.9797C12.4411 15.9797 13.1384 14.9828 13.7965 14.0064C14.5331 12.8875 14.8376 11.7889 14.8572 11.7381C14.7884 11.7177 12.7947 10.8735 12.7947 8.5035C12.7947 6.44882 14.3661 5.5232 14.4545 5.452C13.4134 3.90591 11.8322 3.86523 11.4001 3.86523C10.2313 3.86523 9.27862 4.59758 8.67952 4.59758C8.0313 4.59758 7.17684 3.90591 6.16523 3.90591C4.24023 3.90591 2.28577 5.55372 2.28577 8.66624C2.28577 10.5989 3.01255 12.6434 3.9063 13.9657C4.67237 15.0846 5.34023 16 6.30273 16Z"
      fill="black"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredApple)
const IconSvgColouredApple = createIcon(ForwardRef, 'SvgColouredApple')
export default IconSvgColouredApple
